export default __webpack_public_path__ + "both.6f5cbf9.png";